import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import productsIcon from "svg/products.svg";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import ProductToUpdate from "components/siteRepo/bulkUpdateProducts/productToUpdate";
import ProductUpdatedBy from "components/siteRepo/bulkUpdateProducts/productUpdatedBy";
import "./style.scss";

const BulkUpdateProducts = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedProduct, setSelectedProduct] = useState({});
  const [sites, setSites] = useState([]);

  const contentProps = { setSelectedProduct, selectedProduct, setSites, sites };
  return (
    <div className="container-fluid search-form-container create-site d-flex flex-column bulk-update-products">
      <div className="search-form-container__title d-flex align-items-center">
        <img src={productsIcon} alt="Create site icon" className="create-site__icon" />
        <span className="search-form-container__title--text">Bulk Update Products</span>
      </div>
      <Tabs transition={false} activeKey={location.hash} onSelect={(key) => navigate(`/siteRepo/updateProducts${key}`)}>
        <Tab eventKey="#select-product-tobe-changed" title="Search">
          <ProductToUpdate {...contentProps} />
        </Tab>
        <Tab
          eventKey="#select-product-updated-from"
          title="Update"
          disabled={!selectedProduct?.salesNumber || !sites.length || !sites.some((site) => site.isSelected)}
        >
          <ProductUpdatedBy {...contentProps} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default BulkUpdateProducts;
